import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"
import { SkillGroups } from "../../data/ResumeData"
import { Section, Inner, Label, Heading, reveal, revealDelay } from "./ui"

const Grid = styled.div`
display: grid;
grid-template-columns: repeat(3, 1fr);
gap: 1rem;
margin-top: 0.5rem;

@media (max-width: 56em){ grid-template-columns: repeat(2, 1fr); }
@media (max-width: 36em){ grid-template-columns: 1fr; }
`

const Group = styled(motion.div)`
border: 1px solid ${t.border};
border-radius: 16px;
padding: 1.5rem;
background: ${t.surface};
transition: border-color 0.25s ease, transform 0.25s ease;

&:hover{ border-color: ${t.borderHi}; transform: translateY(-3px); }
`

const Title = styled.h3`
font-family: ${t.mono};
font-weight: 500;
font-size: 0.86rem;
color: ${t.accent};
letter-spacing: 0.04em;
margin-bottom: 1.1rem;
display: flex;
align-items: center;
gap: 0.5rem;

&::before{ content: "—"; color: ${t.faint}; }
`

const Items = styled.ul`
list-style: none;
display: flex;
flex-wrap: wrap;
gap: 0.45rem;
`

const Item = styled.li`
font-size: 0.85rem;
color: ${t.muted};
border: 1px solid ${t.border};
border-radius: 8px;
padding: 0.32rem 0.7rem;
transition: color 0.2s ease, border-color 0.2s ease;

${Group}:hover &{ color: ${t.text}; }
`

const Skills = () => {
    return (
        <Section id="skills" alt>
            <Inner>
                <Label num="03" {...reveal}>Skills &amp; Tools</Label>
                <Heading {...reveal}>The stack I build with.</Heading>
                <Grid>
                    {SkillGroups.map((g, i) => (
                        <Group key={g.title} {...revealDelay(i)}>
                            <Title>{g.title}</Title>
                            <Items>
                                {g.items.map((it) => (
                                    <Item key={it}>{it}</Item>
                                ))}
                            </Items>
                        </Group>
                    ))}
                </Grid>
            </Inner>
        </Section>
    )
}

export default Skills
